module.exports = __webpack_public_path__ + "img/grid-360.4744b251.webp";